document.addEventListener("DOMContentLoaded", (event) => {

  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const variantEvent = isTouch ? 'touchstart' : 'mouseenter';

  document.addEventListener(variantEvent, function(e) {

    const targetEl = e.target instanceof Element ? e.target : e.target.parentElement;
    if (!targetEl) return;

    const swatch = targetEl.closest('.color-swatch');
    if (!swatch) return;
    
    e.preventDefault();
    
    const container = swatch.closest(".color-swatches");
    // --- if clicked +X swatch ---
    if (swatch.classList.contains("color-swatch--more")) {
      container.querySelectorAll(".color-swatch").forEach(el => {
        el.style.display = "";
      });
      swatch.remove(); // remove +X
      return;
    }

    if (swatch.classList.contains("active")) {
      return;
    }

    const productTile = swatch.closest(".product-tile__container");
    if (!productTile) return;

    const images = productTile.querySelectorAll(".product-tile__images-container img");
    if (images.length < 2) return;

    const [firstImg, secondImg] = images;

    const newFirst = swatch.dataset.productVariantFirstImg;
    const newSecond = swatch.dataset.productVariantSecondImg;

    if (newFirst) {
      firstImg.src = newFirst;
      firstImg.removeAttribute("srcset");
    }

    if (newSecond) {
      secondImg.src = newSecond;
      secondImg.removeAttribute("srcset");
    }

    // --- update product price ---
    const priceEl = productTile.querySelector(".product-tile-meta__price");
    if (priceEl && swatch.dataset.productVariantPrice) {
      priceEl.textContent = swatch.dataset.productVariantPrice;
    }

    // --- toggle active state within the group ---
    const group = swatch.parentElement;
    group.querySelectorAll(".color-swatch.active").forEach(el => {
      el.classList.remove("active");
    });
    swatch.classList.add("active");
    
  }, true);

  function prepareColorSwatches() {
    document.querySelectorAll(".color-swatches").forEach(container => {
      const swatches = Array.from(container.querySelectorAll(".color-swatch:not(.color-swatch--more)"));
      const maxVisible = 5;

      // remove any old +X
      container.querySelectorAll(".color-swatch--more").forEach(el => el.remove());

      if (swatches.length > maxVisible) {
        const hiddenCount = swatches.length - maxVisible;

        // hide extras
        swatches.slice(maxVisible).forEach(swatch => {
          swatch.style.display = "none";
        });

        // create +X swatch
        const moreLabel = document.createElement("div");
        moreLabel.className = "color-swatch color-swatch--more";
        moreLabel.textContent = `+ ${hiddenCount}`;
        container.appendChild(moreLabel);
      }
    });
  }
  prepareColorSwatches();

  const colorSwatchesorigFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    if (typeof url === "string" && url.includes("/collections/")) {
      // console.log("Fetching collection products:", url);
    }
    return colorSwatchesorigFetch.apply(this, arguments).then(res => {
      if (res.url.includes("/collections/")) {
        // console.log("Collection products fetched:", res.url);
        setTimeout(()=>{
          prepareColorSwatches();
        },100)
      }
      return res;
    });
  };

});
